import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fieldsWrapper'];

  connect() {
    this.updateAllTermsValues({});
  }

  // Called when a new term is added via nested-form
  // Initializes new term values from previous term
  initProjectTermValues(event) {
    const { fieldset: term, previousFieldset: previousTerm } = event?.detail || {};

    if (!term) return;

    const projectAmount = parseFloat(document.querySelector("form.lending-project-term")?.dataset.projectAmount) || 0;

    const remainingCapitalBefore = parseFloat(
      previousTerm?.querySelector("input[id*='remaining_capital_end_of_period']")?.value
    ) || projectAmount;
    const totalPaidCapital = parseFloat(
      previousTerm?.querySelector("input[id*='total_paid_capital_end_of_period']")?.value
    ) || 0.0;
    const totalPaidInterests = parseFloat(
      previousTerm?.querySelector("input[id*='total_paid_interests_end_of_period']")?.value
    ) || 0.0;

    const remainingCapitalBeginningEl = term.querySelector("input[id*='remaining_capital_beginning_of_period']");
    const remainingCapitalEndEl = term.querySelector("input[id*='remaining_capital_end_of_period']");
    const totalPaidCapitalEl = term.querySelector("input[id*='total_paid_capital_end_of_period']");
    const totalPaidInterestsEl = term.querySelector("input[id*='total_paid_interests_end_of_period']");

    if (remainingCapitalBeginningEl) remainingCapitalBeginningEl.value = remainingCapitalBefore;
    if (remainingCapitalEndEl) remainingCapitalEndEl.value = remainingCapitalBefore;
    if (totalPaidCapitalEl) totalPaidCapitalEl.value = totalPaidCapital;
    if (totalPaidInterestsEl) totalPaidInterestsEl.value = totalPaidInterests;

    this.updateAllTermsValues({});
  }

  // Recalculates all terms (called on every input change)
  updateAllTermsValues(event) {
    const terms = Array.from(
      this.element.querySelectorAll('div[data-nested-form-target="fieldsWrapper"]:not([data-destroyed="true"])')
    ).filter(term => {
      const style = window.getComputedStyle(term);
      return style.display !== 'none';
    });

    terms.forEach((term, index) => {
      // Skip already paid terms (readonly)
      if (term.dataset.isReadonly === "true") {
        return;
      }

      this.updateTotalAmountToPay(term, terms[index - 1]);
    });
  }

  // Calculates amounts for a given term
  updateTotalAmountToPay(term, previousTerm) {
    const projectAmount = parseFloat(document.querySelector("form.lending-project-term")?.dataset.projectAmount) || 0;

    // Get input elements
    const remainingCapitalEndOfPeriodEl = term.querySelector("input[id*='remaining_capital_end_of_period']");
    const totalPaidCapitalEndOfPeriodEl = term.querySelector("input[id*='total_paid_capital_end_of_period']");
    const totalPaidInterestsEndOfPeriodEl = term.querySelector("input[id*='total_paid_interests_end_of_period']");
    const totalAmountToPayEl = term.querySelector("input[id*='total_amount_to_pay']");
    const paymentCapitalShareEl = term.querySelector("input[id*='payment_capital_share']");

    // Input values
    const paymentCapitalShare = parseFloat(paymentCapitalShareEl?.value || 0.0);
    const paymentInterestsShare = parseFloat(term.querySelector("input[id*='payment_interests_share']")?.value || 0.0);
    const lateFees = parseFloat(term.querySelector("input[id*='late_fees']")?.value || 0.0);

    let remainingCapitalBefore = projectAmount;
    let totalPaidCapital = 0.0;
    let totalPaidInterests = 0.0;

    if (previousTerm) {
      remainingCapitalBefore = parseFloat(
        previousTerm.querySelector("input[id*='remaining_capital_end_of_period']")?.value
      ) || projectAmount;
      totalPaidCapital = parseFloat(
        previousTerm.querySelector("input[id*='total_paid_capital_end_of_period']")?.value
      ) || 0.0;
      totalPaidInterests = parseFloat(
        previousTerm.querySelector("input[id*='total_paid_interests_end_of_period']")?.value
      ) || 0.0;
    }

    // Calculate total amount to pay
    const totalAmountToPay = (paymentCapitalShare + paymentInterestsShare + lateFees).toFixed(2);

    // Update calculated fields
    if (totalAmountToPayEl) totalAmountToPayEl.value = totalAmountToPay;

    const remainingCapitalBeginningEl = term.querySelector("input[id*='remaining_capital_beginning_of_period']");
    if (remainingCapitalBeginningEl) remainingCapitalBeginningEl.value = remainingCapitalBefore;
    if (remainingCapitalEndOfPeriodEl) remainingCapitalEndOfPeriodEl.value = (remainingCapitalBefore - paymentCapitalShare).toFixed(2);
    if (totalPaidCapitalEndOfPeriodEl) totalPaidCapitalEndOfPeriodEl.value = (totalPaidCapital + paymentCapitalShare).toFixed(2);
    if (totalPaidInterestsEndOfPeriodEl) totalPaidInterestsEndOfPeriodEl.value = (totalPaidInterests + paymentInterestsShare + lateFees).toFixed(2);

    // Validate capital share
    this.validateCapitalShare(paymentCapitalShareEl, paymentCapitalShare, remainingCapitalBefore);
  }

  // Validate that capital share doesn't exceed remaining capital
  validateCapitalShare(paymentCapitalShareEl, paymentCapitalShare, remainingCapitalBefore) {
    if (!paymentCapitalShareEl) return;

    const errorParent = paymentCapitalShareEl.closest('li');
    if (!errorParent) return;

    // Remove existing errors
    errorParent.querySelectorAll('p.inline-errors').forEach(el => el.remove());

    if (paymentCapitalShare > remainingCapitalBefore) {
      errorParent.classList.add('error');
      const errorMessage = document.createElement('p');
      errorMessage.className = 'inline-errors';
      errorMessage.textContent = paymentCapitalShareEl.dataset.onError;
      errorParent.appendChild(errorMessage);
      this.element.querySelector("input[type='submit']")?.setAttribute('disabled', 'true');
    } else {
      errorParent.classList.remove('error');
      this.element.querySelector("input[type='submit']")?.removeAttribute('disabled');
    }
  }
}
